<div class="box-theme">
    <div class="head">
        <div class="header">
            <div class="ico">
                <img src="./assets/img/icono-info2.png" alt="Información de tu cuenta">
            </div>
        </div>
        <div class="body">
            <h1>Información de tu cuenta</h1>
            <p>En esta sección podrás conocer el estado de tu cuenta, detalles de tu consumo y tu historial.</p>
        </div>
    </div>
    <div class="body">
        <div class="paso-2">
            <div class="body">
                <form [formGroup]="formData">
                    <div class="form">
                        <div class="head">
                            <h2>
                                Completa los campos
                            </h2>
                            <p class="txt-orange">
                                (**datos obligatorios)
                            </p>
                        </div>
                        <div class="body body-datos-cliente">
                            <ul>
                                <li>
                                    <div class="box-campo-form">
                                        <div class="cont-numero-cliente">
                                            <input type="text" placeholder="**Número de cliente" [maxLength]="9" formControlName="nCliente" [ngClass]="{ 'is-invalid': submitted && f.nCliente.errors }" />
                                            <div class="error" *ngIf="formData.get('nCliente')?.errors?.numClienteValid || formData.get('nCliente')?.errors?.numClienteExist">
                                                <p> número de cliente inválido</p>
                                            </div>
                                            <div class="div-numero-cliente">
                                                <a style="cursor: pointer;" (click)="mostrarNumeroCliente()">
                                                    <img class="info-numero-cliente" src="./assets/img/info-icon.png" alt="Información número de cliente">
                                                </a>
                                            </div>
                                            <div class="error">
                                                <div *ngIf="submitted && f.nCliente.errors">
                                                    <p *ngIf="f.nCliente.errors.required">
                                                        dato obligatorio
                                                    </p>
                                                    <p *ngIf="f.nCliente.errors.maxlength || f.nCliente.errors.pattern || f.nCliente.errors.numClienteValid">
                                                        número de cliente inválido
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="box-campo-form">
                                        <input type="text" placeholder="**Dirección de cliente" formControlName="direccion" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.direccion.errors }" disabled />
                                        <br><br>
                                    </div>
                                </li>
                            </ul>
                            <div class="footer">
                                <div class="callToAcction">
                                    <input type="button" value="BUSCAR" class="btn btn-continuar" (click)="onSubmit()">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="contenedor-resultado" *ngIf="infoCliente" id="resultado">
            <div class="paso-2 box-estado-conexion" *ngIf="mostrarDatos">
                <div class="body">
                    <div class="form">
                        <div class="head">
                            <h2>Estado de su conexión</h2>
                        </div>
                        <div class="body body-dos">
                            <div class="aviso-estado " *ngIf="servicioCorte(this.estadoCliente.estadoServicio.ConsultarEstadoServicioPorCuentaContratoResponse)">
                                <p class="msj-estado">DESCONECTADO</p>
                                <p class="txt-estado">Su suministro se encuentra <span>desconectado por deuda</span>, debe regularizar para solicitar reposición de servicio.</p>
                            </div>

                            <div class="aviso-estado " *ngIf="servicioReposicion(this.estadoCliente.estadoServicio.ConsultarEstadoServicioPorCuentaContratoResponse)">
                                <p class="msj-estado">Orden de reposición ingresada</p>
                                <p class="txt-estado">Su suministro se encuentra <span>en proceso de reposición</span>.</p>
                            </div>

                            <div class="aviso-estado " *ngIf="servicioCorteTramite(this.estadoCliente.estadoServicio.ConsultarEstadoServicioPorCuentaContratoResponse)">
                                <p class="msj-estado">Orden de corte no ejecutada</p>
                                <p class="txt-estado">Su suministro se encuentra <span>con corte en trámite</span>.</p>
                            </div>

                            <div class="aviso-estado" *ngIf="servicioNormal(this.estadoCliente.estadoServicio.ConsultarEstadoServicioPorCuentaContratoResponse)">
                                <p class="msj-estado">CONECTADO</p>
                                <p class="txt-estado">Su suministro se encuentra <span>conectado</span>.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="paso-2 box-info-deuda">
                <div class="body">
                    <div class="form">
                        <div class="head">
                            <h2>Información de deuda y saldo anterior</h2>
                        </div>
                        <div class="body-detalle">
                            <ul>
                                <li>
                                    <div class="box-detalle">
                                        <h3>Deuda total</h3>
                                        <p>$ {{formatCLP(estadoCliente.saldoActual.Saldo.MontoTotal)}}</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="box-detalle">
                                        <h3>Fecha de vencimiento</h3>
                                        <p>{{formatearFecha(estadoCliente.saldoActual.Saldo.FechaVenc)}}</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="box-detalle">
                                        <h3>Saldo anterior </h3>
                                        <p>$ {{formatCLP(estadoCliente.saldoAnterior.Saldo.MontoTotal)}}</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="box-detalle">
                                        <h3>Último pago realizado</h3>
                                        <p>${{formatCLP(estadoCliente.ultimoPago.MontoUltimoPago)}}
                                            <br>${{formatCLP(estadoCliente.ultimoPago.CanalUltimoPago)}}
                                            <br> {{formatearFecha(estadoCliente.ultimoPago.FechaUltimoPago)}}
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="paso-2 box-historial">
                <div class="head">
                    <h2>Historial</h2>
                </div>

                <chart [type]="type" [data]="data" [options]="options"></chart>
                <div class="body-tabla">
                    <table>
                        <thead>
                            <tr>
                                <td>
                                    <h5>Período de consumo</h5>
                                </td>
                                <td>
                                    <h5>Consumo M3</h5>
                                </td>
                                <td>
                                    <h5>Total Boleta ($)</h5>
                                </td>
                                <td>
                                    <h5>Nº Boleta</h5>
                                </td>
                                <td>
                                    <h5>Estado</h5>
                                </td>
                            </tr>
                        </thead>
                        <tbody *ngFor="let info of estadoCliente.documentosVenta.ConsultarDocumentosVentaResponse.Documentos.item">
                            <tr>
                                <td>
                                    <p>{{info.FechaEmic}} - {{info.FechaVenc}}</p>
                                </td>
                                <td>
                                    <p>{{info.ConsumoCorrM3}}</p>
                                </td>
                                <td>
                                    <p>{{formatCLP(info.Monto)}}</p>
                                </td>
                                <td>
                                    <div class="box-boleta">
                                        <p>{{info.DocumentoVenta}}</p>
                                        <a class="icn-download">
                                        </a>
                                    </div>
                                </td>
                                <td>
                                    <div class="box-estado-boleta" *ngIf="info.IndicadorPago ===''">
                                        <img src="../../assets/img/icono-pendiente.png" alt=""> PENDIENTE
                                    </div>
                                    <div class="box-estado-boleta" *ngIf="info.IndicadorPago ==='X'">
                                        <img src="../../assets/img/icono-pagado.png" alt=""> PAGADO

                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                <p class="descripcion-scroll">Desliza hacia los lados para visualizar las columnas de la tabla</p>
            </div>
        </div>

        <div class="footer" *ngIf="mostrarContacto">
            <div class="callToAcction">
                <p>Si necesita información adicional, presione el botón para enviarnos su consulta.</p>
                <input type="button" value="Realizar una consulta" class="btn btn-continuar" [routerLink]="['/contactenos']">
            </div>
        </div>


    </div>
</div>



<div class="modal-requerido">
    <div class="punto-informacion">
        <h3>Debes completar todos los datos solicitados para continuar</h3>
        <div class="callToAcction">
            <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
        </div>
    </div>
</div>

<div class="modal-error">
    <div class="punto-informacion">
        <h3>Ha ocurrido un error, vuelva a intentarlo más tarde</h3>
        <div class="callToAcction">
            <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
        </div>
        <br>
    </div>
</div>


<div class="modal-numero-cliente">
    <div class="punto-informacion">
        <!--<img class='img-numero-cliente' src='./assets/img/numero_cliente.png'>-->
        <img class='img-numero-cliente' src='./assets/img/conoce-numero-cliente.jpg' alt="Conoce tu número de cliente">
        <br>
        <p class="texto-numero-cliente">
            Si no tienes tu número de cliente obtenlo ingresando tu dirección en metrogas.cl
            <!--El número de cliente aparece en la parte superior de su boleta de gas.-->
        </p>
        <div class="callToAcction">
            <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
        </div>
        <br>
    </div>
</div>

<ngx-spinner></ngx-spinner>
